
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class AlertModal extends Vue {

    @Prop() title: string;
    @Prop() text: string;
    @Prop({
        default: 'OK'
    }) okText: string;
    @Prop() okCallback: () => Promise<any>;

    name: string = Date.now().toString();

    mounted(){
        (this.$refs.closeButton as HTMLButtonElement).focus();
    }

    async ok(){
        if(this.okCallback){
            await this.okCallback();
        }
        this.$emit('close');
    }
}
